<template>
  <b-nav-item>
    <div class="d-inline-block">
     <span class="vertical-middle">
       <help-svg class="help-svg"/>
    </span>
    <span class="text-help vertical-middle">
      Help
    </span>
    </div>
  </b-nav-item>
</template>

<script>
import { BNavItem } from 'bootstrap-vue'
import HelpSvg from "@/@core/components/svg/common/HelpSvg.vue"

export default {
  components: {
    BNavItem,
    HelpSvg
  },
  setup() {
  },
}
</script>

<style scoped>
  @import "~@/assets/css/override-styles/horizontal-headerbar.css";
</style>
